import type { SurfaceRecordParentResolver } from '@workbuddy/ui/v2/surface.engine';
import { getManifest } from './entity.manifest.registry';

/** Surface record parents answered by each entity's manifest `parentOf`. */
export const manifestRecordParent: SurfaceRecordParentResolver = (entity, record) => getManifest(entity)?.parentOf?.(record) ?? [];
